module.exports = __webpack_public_path__ + "img/fire-pit.a409e7fe.jpeg";